import { render } from "./calenderGeneral.vue?vue&type=template&id=33ef3dda"
import script from "./calenderGeneral.vue?vue&type=script&lang=js"
export * from "./calenderGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__